import { translations } from '@aws-amplify/ui-react';
import { Typography } from '@mui/material';
import { I18n } from 'aws-amplify/utils';
import { amplifyTranslateImpl } from '../amplifyI18n';
import Logo from './logo.png';
import StyledBox from './styles';

I18n.putVocabularies(translations);
I18n.putVocabulariesForLanguage('fr', {
  'login.title': 'Se connecter à CogNeed',
  'login.password': 'Entrez votre mot de passe',
  'login.email': 'Entrez votre adresse e-mail',
  'login.remember_me': 'Se souvenir de mon adresse e-mail',
  'reset_password.title': 'Réinitialiser votre mot de passe',
  'accept_conditions.title': "*En vous connectant, vous acceptez nos <1>conditions générales d'utilisation</1> et notre <3>politique de confidentialité</3>.",
  'conditions.link': 'https://www.cogneed.ai/conditions-generales-vente-utilisation',
  'privacy_policy.link': 'https://www.cogneed.ai/politique-de-confidentialite',
  'login.sync-app': "Lier l'application à votre compte",
  SSO_REQUIRED: "L'organisation {org} nécessite une connexion SSO pour les adresses e-mail {domain}.",
  'login.sign-in': 'Se connecter',
  'login.having-issues': 'Vous rencontrez des problèmes ?',
  'login.trouble-text': "Essayez d'effacer le stockage et de synchroniser à nouveau.",
  'login.clear-storage': 'Effacer le stockage',
  'login.sync-error': "La connexion a échoué. Essayez d'effacer le stockage et de synchroniser à nouveau.",
  'login.sync-error-unknown': 'Erreur inconnue',
  'login.sign-in-in-app': "Se connecter dans l'application",
});
I18n.putVocabulariesForLanguage('en', {
  'login.title': 'Sign in to CogNeed',
  'login.password': 'Enter your password',
  'login.email': 'Enter your email address',
  'login.remember_me': 'Remember my email address',
  'reset_password.title': 'Reset your password',
  'accept_conditions.title': '*By signing in, you agree to our <1>terms of service</1> and our <3>privacy policy</3>.',
  'conditions.link': 'https://www.cogneed.ai/en/terms-of-service',
  'privacy_policy.link': 'https://www.cogneed.ai/en/privacy-policy',
  'login.sync-app': 'Link the application to your account',
  SSO_REQUIRED: 'Organization {org} requires SSO login for {domain} email addresses.',
  'login.sign-in': 'Sign in',
  'login.having-issues': 'Having issues?',
  'login.trouble-text': 'Try clearing the storage and syncing again.',
  'login.clear-storage': 'Clear storage',
  'login.sync-error': 'Sign-in failed. Try clearing the storage and syncing again.',
  'login.sync-error-unknown': 'Unknown error',
  'login.sign-in-in-app': 'Sign in inside the app',
});

export default function SignInHeader() {
  return (
    <StyledBox maxWidth="sm">
      <div className="logo">
        <img src={Logo} style={{ width: '100%', height: 'auto' }} alt="CogNeed logo" />
      </div>
      <Typography variant="h1">
        {amplifyTranslateImpl('login.title')}
      </Typography>
    </StyledBox>
  );
}
